"use strict";
/* eslint-disable @typescript-eslint/ban-ts-comment */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const HelperUtils_1 = require("utils/HelperUtils");
const HighlightedBubble = ({ setOnboardStatus, onBoardStatus }) => {
    const bubbleRef = (0, react_1.useRef)(null);
    const [topPosition, setTopPosition] = (0, react_1.useState)(0);
    const [leftPosition, setLeftPosition] = (0, react_1.useState)(0);
    const [visibility, setVisibility] = (0, react_1.useState)(false);
    const closeBubble = () => {
        setOnboardStatus(false);
        setVisibility(false);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (!onBoardStatus)
            return;
        const containerEl = (_a = bubbleRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (!containerEl)
            return;
        const observer = new MutationObserver((mutationList) => {
            mutationList.forEach(function (mutation) {
                if (mutation.type != 'childList')
                    return;
                const bookmarks = document.querySelector('.bookmarks');
                if (!bookmarks)
                    return;
                observer.disconnect();
                const bookmarkSelected = document.querySelector('.bookmarks.bg-base-600');
                if (bookmarkSelected) {
                    setOnboardStatus(false);
                    return;
                }
                const rect = bookmarks.getBoundingClientRect();
                setTopPosition(rect.top);
                setLeftPosition(rect.left);
                setVisibility(true);
            });
        });
        observer.observe(containerEl, { childList: true, subtree: true });
        return () => {
            closeBubble();
            observer.disconnect();
        };
    }, [onBoardStatus]);
    return (react_1.default.createElement("div", { ref: bubbleRef }, visibility && (react_1.default.createElement(Content, { topPosition: topPosition, leftPosition: leftPosition, closeBubble: closeBubble }))));
};
const Content = ({ topPosition, leftPosition, closeBubble }) => {
    const sharedTooltip = document.getElementById(`shared-tooltip`);
    if (!sharedTooltip)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "w-[100vw] h-[100vh] fixed top-[0] left-[0] z-[10]" },
        react_1.default.createElement("div", { className: "fixed z-[9] flex flex-row", style: { top: topPosition + 16, left: leftPosition - 5 } },
            react_1.default.createElement("svg", { width: "90px", height: "90px" },
                react_1.default.createElement("path", { d: "M 13 10 l 0 20 c 0 20, 10 20, 20 20 l 44 0", stroke: "var(--base-600)", fill: "none", strokeWidth: 2 }),
                react_1.default.createElement("g", null,
                    react_1.default.createElement("circle", { cx: 13, cy: 10, r: 6, stroke: "none", fill: "var(--base-600)" }),
                    react_1.default.createElement("circle", { cx: 13, cy: 10, r: 10, stroke: "none", fill: "var(--base-600)", opacity: 0.2 }),
                    react_1.default.createElement("path", { d: "M 75 44 L 84 50 L 75 56 z", fill: "var(--base-600)" }))),
            react_1.default.createElement("div", { className: "bg-base-700 p-[24px] w-[400px] shadow-raised rounded-[8px] mt-[12px]" },
                react_1.default.createElement("p", { className: "typography-h700 text-n-000" }, (0, HelperUtils_1.getObjectiveLocale)("Let's Highlight some goals!")),
                react_1.default.createElement("p", { className: "typography-h500 text-n-000 mt-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)('You can highlight your goals by clicking this icon')),
                react_1.default.createElement("div", { className: "flex justify-end mt-[28px]" },
                    react_1.default.createElement("div", { className: "bg-base-600 rounded px-[16px] py-[8px] cursor-pointer", onClick: closeBubble },
                        react_1.default.createElement("p", { className: "typography-button text-n-100" }, (0, HelperUtils_1.getObjectiveLocale)('Got it'))))))), sharedTooltip);
};
exports.default = HighlightedBubble;
